// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ServiceType,
} from "./types";

export default {
  name: __t.string(),
  get serviceType() {
    return ServiceType;
  },
  projectId: __t.u32(),
  targetModules: __t.string(),
  description: __t.string(),
  displayName: __t.string(),
};
